const initialState = {
  image: null,
  isOpen: false
};

export const imageEditorReducer = (state = initialState, action) => {
  switch (action.type) {
    case "RESET_IMAGE_EDITOR": {
      return initialState;
    }
    case "SET_IMAGE_EDITOR": {
      return { ...state, ...action.imageEditor };
    }
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/image-editor.js